var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t('contacts'))+" "),_c('v-spacer'),_c('v-icon',{on:{"click":function($event){return _vm.$emit('input')}}},[_vm._v("mdi-close")])],1),_c('v-card-text',[_c('contacts-body')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }